package pwgs.ui.scenes.playerscene

import pwgs.ui.scenes.customentityeditorscene.CustomEntityEditorScene
import pwgs.ui.scenes.customentityeditorscene.CustomEntityEditorSceneProps
import pwgs.ui.scenes.playererrorsscene.PlayerErrorsScene
import pwgs.ui.scenes.playererrorsscene.PlayerErrorsSceneProps
import pwgs.ui.scenes.playerlogsscene.PlayerLogsScene
import pwgs.ui.scenes.playerlogsscene.PlayerLogsSceneProps
import visage.core.AComponent
import visage.core.Components
import visage.core.AScene
import visage.dom.tag
import visage.ds.components.*
import visage.ds.components.page.Page
import visage.ds.utils.ETextAlign

class MPlayerSceneScene(props: PlayerSceneProps) :
    AScene<PlayerSceneProps, PlayerSceneModel, PlayerSceneSceneState, PlayerSceneControllerFe>(props) {

    override fun createController(): PlayerSceneControllerFe {
        return PlayerSceneControllerFe(props, this)
    }

    override fun initState(): PlayerSceneSceneState {
        return PlayerSceneSceneState()
    }

    override fun Components.render(children: List<AComponent<*>>) {
        val props = this@MPlayerSceneScene.props
        val model = this@MPlayerSceneScene.model
        Page {
            head("Player: " + model.name)
            tab("Data") {
                CustomEntityEditorScene(
                    CustomEntityEditorSceneProps(
                        props.projectId,
                        "Player",
                        props.playerId,
                    )
                )
            }
            tab("Ban") {
                Card {
                    isLoading = model.isLoading
                    header("Ban player")
                    body {
                        tag("div") {
                            style.apply {
                                display = "block"
                                padding = "16px"
                            }
                            if (model.isBanned) {
                                Text(
                                    "Player is already banned until ${model.bannedUntil} because:\n${model.banReason.value}",
                                    ETextStyles.Normal,
                                    true
                                ) {
                                    textAlign = ETextAlign.CENTER
                                }

                                tag("div") {style.apply { height = "16px"; minHeight = "16px" }}

                                Button("Unban") {
                                    color = EButtonColor.Success
                                    onClick = this@MPlayerSceneScene.controller::onUnbanButtonClick
                                }
                            } else {
                                if (model.bannedUntil == "") {
                                    Text(
                                        "Player is never banned before",
                                        ETextStyles.Normal,
                                        true
                                    ) {
                                        textAlign = ETextAlign.CENTER
                                    }
                                }
                                else {
                                    Text(
                                        "Player was last banned at ${model.bannedUntil}",
                                        ETextStyles.Normal,
                                        true
                                    ) {
                                        textAlign = ETextAlign.CENTER
                                    }
                                }


                                tag("div") {style.apply { height = "16px"; minHeight = "16px" }}

                                TextField("Interval", model.banInterval)

                                tag("div") {style.apply { height = "16px"; minHeight = "16px" }}

                                Select("Interval type", model.banIntervalType)

                                tag("div") {style.apply { height = "16px"; minHeight = "16px" }}

                                TextArea("Reason", model.banReason)

                                tag("div") {style.apply { height = "16px"; minHeight = "16px" }}

                                Button("Ban") {
                                    color = EButtonColor.Danger
                                    onClick = this@MPlayerSceneScene.controller::onBanButtonClick
                                }
                            }
                        }
                    }
                }
            }

            tab("Issues") {
                PlayerErrorsScene(PlayerErrorsSceneProps(props.projectId, props.playerId))
            }
            tab("Remote log") {
                PlayerLogsScene(PlayerLogsSceneProps(props.projectId, props.playerId))
            }
        }
    }
}

class PlayerSceneSceneState {

}

fun Components.PlayerSceneScene(props: PlayerSceneProps) = this.registerComponent(MPlayerSceneScene(props), {})
